import { render, staticRenderFns } from "./OptionArticleSimpleTable.vue?vue&type=template&id=9c14c33a"
import script from "./OptionArticleSimpleTable.vue?vue&type=script&lang=ts"
export * from "./OptionArticleSimpleTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports